<template>
    <div class="file-card">
        <b-form-row class="preview">
            <b-col
                    cols="8"
                    md="9"
                    class="left-items"
            >
                <file-thumbnail :file="file" />
                <div class="details">
                    <div class="filename">
{{ file.name }}
</div>
                </div>
            </b-col>
            <b-col
                    cols="4"
                    md="3"
                    class="right-items"
            >
                <span
                        class="remove fal fa-times"
                        @click="$emit('remove-file', file)"
                />
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
    import FileThumbnail from './FileThumbnail';

    export default {
        name: 'FileCard',
        components: {
            FileThumbnail
        },
        props: {
            file: {
                type: [File, Object],
                required: true
            }
        }
    };
</script>

<style
        lang="scss"
        scoped
>
    @import "../../scss/foundation";

    .file-card {
        .preview {
            box-sizing:       border-box;
            height:           4.375rem;
            border:           1px solid $gray-400;
            border-radius:    2px;
            background-color: $gray-100;
            margin:           0 0 10px;
            padding:          15px;

            .center-items {
                display:         flex;
                justify-content: center;
                align-items:     center;
            }

            .left-items {
                display:         flex;
                justify-content: flex-start;
                align-items:     center;
            }

            .right-items {
                display:         flex;
                justify-content: flex-end;
                align-items:     center;
            }

            .details {
                overflow:    hidden;
                margin-left: 15px;

                .filename {
                    color:          $gray-800;
                    font-family:    $headings-font-family;
                    font-size:      1rem;
                    font-weight:    800;
                    letter-spacing: 0.3px;
                    white-space:    nowrap;
                    overflow:       hidden;
                    text-overflow:  ellipsis;
                }

            }

            .remove {
                color:       $gray-700;
                font-size:   1.3rem;
                margin-left: 15px;
                cursor:      pointer;
            }
        }
    }
</style>
